module.exports = {"520123100":"龙场镇","520123101":"扎佐镇","520123102":"久长镇","520123103":"六广镇","520123104":"六屯镇","520123105":"洒坪镇","520123106":"六桶镇","520123200":"谷堡乡","520123202":"小箐乡","520123204":"大石布依族乡","520123400":"龙岗社区服务中心","520123401":"珍珠河社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520123.json
// module id = 2269
// module chunks = 0